module.exports = __webpack_public_path__ + "static/media/nkem-bio.96dcc683.jpeg";